// Generated by Copilot- Start
import { useCallback, useState } from "react";
import { ChannelCardV2 } from "lib/helper/channel-interactive-tool-v2";

export interface ModalState {
  activeChannel: ChannelCardV2 | null;
  clickedShow: any | null;
}

export interface ModalHandlers {
  activeChannel: ChannelCardV2 | null;
  clickedShow: any | null;
  handleChannelClick: (channel: ChannelCardV2) => void;
  handleChannelClose: () => void;
  handleShowClick: (show: any) => void;
  handleShowClose: () => void;
}

export const useModalHandlers = (packageSummaries: Record<string, any> = {}, svodTiles: any[] = []): ModalHandlers => {
  const [activeChannel, setActiveChannel] = useState<ChannelCardV2 | null>(null);
  const [clickedShow, setClickedShow] = useState<any>(null);

  const handleChannelClick = useCallback(
    (channel: ChannelCardV2) => {
      // LOCAL and RSN channels always open modals (they have special modal types).
      // Detect via the structural flags (stable across genre injection); categoryId
      // is kept as a Stage-1 safety net.
      const isLocalOrRsn = Boolean(channel.isLocal || channel.isRsn) || channel.categoryId === "LOCAL" || channel.categoryId === "RSN";

      if (isLocalOrRsn) {
        setActiveChannel(channel);
        return;
      }

      // For other channels, check if they have packages
      const hasPackages = (channel.signaturePackages && channel.signaturePackages.length > 0) || (channel.genrePackages && channel.genrePackages.length > 0);

      // For MyFreeDTV channels, check packageSummaries
      const isMyFreeDtvChannel = channel.isMyFreeDTV;
      const hasMyFreeDtvPackage = isMyFreeDtvChannel && packageSummaries?.["MyFree DIRECTV"];

      // For SVOD channels, check svodTiles
      const isSvodChannel = channel.categoryId === "SVOD";
      const hasSvodData = isSvodChannel && svodTiles?.length > 0;

      if (!hasPackages && !hasMyFreeDtvPackage && !hasSvodData) {
        return;
      }

      setActiveChannel(channel);
    },
    [packageSummaries, svodTiles]
  );

  const handleChannelClose = useCallback(() => {
    setActiveChannel(null);
  }, []);

  const handleShowClick = useCallback((show: any) => {
    setClickedShow(show);
  }, []);

  const handleShowClose = useCallback(() => {
    setClickedShow(null);
  }, []);

  return {
    activeChannel,
    clickedShow,
    handleChannelClick,
    handleChannelClose,
    handleShowClick,
    handleShowClose
  };
};
// Generated by Copilot- End
